import { Helmet } from 'react-helmet-async'

export default function NotFoundErrorPage() {
  return (
    <div className="page-container">
      <Helmet>
        <title>Oops</title>
      </Helmet>
      <main className="page-main-content">
        <div className="page-content">
          <div className="dashboard-top-image">
            <img src="/images/logo_1.png" alt="SoloProtect Banner" className="top-logo-image" />
          </div>
          <div className="dashboard-content-wrapper">
            <div className="dashboard-welcome">
              <h1>404 Page Not Found</h1>
            </div>
            <div className="dashboard-middle-right-image">
              <img src="/images/Worker_Image.png" alt="Device Management" className="middle-right-image" />
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
